// extracted by mini-css-extract-plugin
module.exports = {"shareItem":"SharePopupContent_shareItem__LE0H3","xcom":"SharePopupContent_xcom__7rjB9","shareButton":"SharePopupContent_shareButton__F_AAH"};